<template>
  <iframe src="//demo.buzzoola.com/vast_validator_demo/" frameborder="0"></iframe>
</template>


<script>
export default {
  name: 'VastValidator',
};
</script>

<style scoped lang='stylus'>
iframe
  border 0
  width 100%
  height 100%
  position absolute
  left 0
  top 0
</style>
